module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-06.48e7422b.png";